import React from 'react'
import { subscriberColumns } from '../../utils/data/accountDetails';
import DataTable from 'react-data-table-component';
import { customStyles } from '../../utils/data/essential';
const AccountOwner = ({ ownerData, showUpdateModal }) => {
  const roles = JSON.parse(localStorage.getItem("roles"));
    const columns = subscriberColumns(showUpdateModal,roles)
  return (
    <div>
      <div className='d-flex justify-content-center mt-4'>
        <h4 className='mt-3' style={{ fontWeight: 600 }}>
          Account Owner
        </h4>
      </div>
      <div className='table-responsive datatables dataValidation-Wrap thead-primary pr-3 pl-3 mr-2'>
        <DataTable
          columns={columns}
          data={ownerData}
          responsive={true}
          customStyles={customStyles}
          highlightOnHover
          striped
          noHeader
        />
      </div>
    </div>
  );
}

export default AccountOwner